export default "__VITE_ASSET__636b7aca__"